import { Outlet } from 'react-router';
import { Layout } from './components/Layout';

function App() {
  return (
    <>
      <style>{`
        :root {
          --bg: #0B1220;
          --panel: #0F1B2E;
          --card: #0E1A2B;
          --text: #EAF0FF;
          --muted: #A9B4CC;
          --line: rgba(255,255,255,0.10);
          --g1: #81A63F;
          --g2: #7DA339;
          --g3: #5E752E;
          --accentK: #2F6BFF;
          --accentE: #E6C35A;
          --r1: 14px;
          --r2: 22px;
          --shadow1: 0 10px 30px rgba(0,0,0,0.35);
        }

        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          font-size: 16px;
          line-height: 1.6;
          color: var(--text);
          background-color: var(--bg);
        }

        .btnPrimary:hover {
          background-color: var(--g2) !important;
          transform: translateY(-1px);
          box-shadow: var(--shadow1);
        }

        .btnPrimary:focus-visible {
          outline: 2px solid var(--g1);
          outline-offset: 2px;
        }

        .btnSecondary:hover {
          background-color: var(--card) !important;
          border-color: var(--g1) !important;
        }

        .btnSecondary:focus-visible {
          outline: 2px solid var(--g1);
          outline-offset: 2px;
        }

        .btnGhost:hover {
          background-color: var(--panel) !important;
        }

        .btnGhost:focus-visible {
          outline: 2px solid var(--g1);
          outline-offset: 2px;
        }

        .cardHover:hover {
          transform: translateY(-2px);
          box-shadow: var(--shadow1);
          border-color: var(--g1);
        }

        input:focus-visible,
        textarea:focus-visible,
        select:focus-visible {
          outline: 2px solid var(--g1);
          outline-offset: 2px;
        }

        .navLink:hover {
          color: var(--g1) !important;
        }

        .navLinkActive {
          color: var(--g1) !important;
        }

        .footerLink:hover {
          color: var(--g1) !important;
        }

        .breadcrumbLink:hover {
          color: var(--g1) !important;
        }

        .learnMoreLink:hover {
          color: var(--g2) !important;
        }

        .emailLink:hover {
          color: var(--g2) !important;
        }

        .relatedItem:hover {
          border-color: var(--g1) !important;
        }

        .backLink:hover {
          background-color: var(--panel) !important;
          border-color: var(--g1) !important;
        }

        .sectionPadding {
          padding-top: 72px;
          padding-bottom: 72px;
        }

        @media only screen and (max-width: 860px) {
          .sectionPadding {
            padding-top: 52px;
            padding-bottom: 52px;
          }

          .headerNav {
            display: none !important;
          }

          .headerActions {
            display: none !important;
          }

          .hamburgerBtn {
            display: block !important;
          }

          .heroGrid {
            grid-template-columns: 1fr !important;
          }

          .heroTitle {
            font-size: 34px !important;
          }

          .sectionTitle {
            font-size: 26px !important;
          }

          .pageTitle {
            font-size: 34px !important;
          }

          .pillarsGrid {
            grid-template-columns: 1fr !important;
          }

          .featuredGrid {
            grid-template-columns: 1fr !important;
          }

          .roadmapGrid {
            grid-template-columns: 1fr !important;
          }

          .partnersGrid {
            grid-template-columns: 1fr !important;
          }

          .newsGrid {
            grid-template-columns: 1fr !important;
          }

          .newsListGrid {
            grid-template-columns: 1fr !important;
          }

          .aboutGrid {
            grid-template-columns: 1fr !important;
          }

          .operatingModelGrid {
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .sectorsGrid {
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .partnerSection {
            grid-template-columns: 1fr !important;
          }

          .officesGrid {
            grid-template-columns: 1fr !important;
          }

          .contactGrid {
            grid-template-columns: 1fr !important;
          }

          .eventDetailGrid {
            grid-template-columns: 1fr !important;
          }

          .newsDetailGrid {
            grid-template-columns: 1fr !important;
          }

          .benefitsGrid {
            grid-template-columns: 1fr !important;
          }

          .formRow {
            grid-template-columns: 1fr !important;
          }

          .newsFilters {
            grid-template-columns: 1fr !important;
          }

          .heroStats {
            grid-template-columns: 1fr !important;
          }
        }

        @media only screen and (max-width: 600px) {
          .operatingModelGrid {
            grid-template-columns: 1fr !important;
          }

          .sectorsGrid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
      <Layout>
        <Outlet />
      </Layout>
    </>
  );
}

export default App;
